import {deepMergeAll} from 'tizra'
import * as A from '../admin'

export interface ThemeBlockGlobalConfig {
  buttonColor: string
  linkColor: string
  logoUrl: string
  logoLink: string
  bodyFont: 'sans' | 'serif'
  headingFont: 'sans' | 'serif'
}

export const defaultGlobalConfig: ThemeBlockGlobalConfig = {
  buttonColor: '',
  linkColor: '',
  logoUrl: '/aa_shared/quickstart/assets/logo.png',
  logoLink: '/',
  bodyFont: 'sans',
  headingFont: 'sans',
}

// This is special! Instead of A.GlobalMigrate<ThemeBlockGlobalConfig>
// we require only a subset of props. The result is type-compatible but makes it
// easier to implement createBrandedTheme() which needs to run sometimes where
// it's hard to access ThemeBlock.info.globalMigrate (the enhanced wrapper)
// because of circular imports.
export const globalMigrate = ({
  globalConfig: unknownGlobalConfig,
}: {
  globalConfig: unknown
  hacks: string[] // available here if we need it
}): ThemeBlockGlobalConfig => {
  const globalConfig = {
    ...(unknownGlobalConfig as any),
  } as Partial<ThemeBlockGlobalConfig>
  return deepMergeAll(defaultGlobalConfig, globalConfig)
}

export const GlobalAdmin: A.Admin<ThemeBlockGlobalConfig> = () => {
  const fontOptions = A.options({
    sans: 'Sans Serif',
    serif: 'Serif',
  })
  return (
    <>
      <A.Group title="Colors">
        <A.Input label="Button color" name="buttonColor" />
        <A.Input label="Link color" name="linkColor" />
      </A.Group>
      <A.Group title="Logo">
        <A.Input label="Logo Image URL" name="logoUrl" />
        <A.Input label="Logo links to" name="logoLink" />
      </A.Group>
      <A.Group title="Typography">
        <A.Select label="Headings" name="headingFont" options={fontOptions} />
        <A.Select label="Body" name="bodyFont" options={fontOptions} />
      </A.Group>
    </>
  )
}

export const Admin = () => null
